// export const BASE_URL =  "http://localhost:5000/api";
export const BASE_URL = "https://sb-agreement-api.consoledot.com/api";
